import React, { useEffect, useState } from "react";
import { Container, Card, Button, Typography, Grid, CardActions, LinearProgress, Divider, Skeleton, Dialog } from '@mui/material';
import { useNavigate, useParams } from "react-router-dom";
import Header from "./title";
import { useUserDetailsQuery, useUserDeleteMutation, useDisableUserMutation } from "services/user";
import { useOrgDetailsQuery } from "services/org";
import { useGetRoleByCodeQuery } from "services/role";
import { useSelector, useDispatch } from "react-redux";
import { resetRequestId } from 'api/user';
import ChangePassword from "./change-password";
import { useUserCognitoDetailsQuery } from 'services/user';
import { useSubscriptionDetailsQuery } from "services/subscription";
import moment from 'moment-timezone';
import SubscriptionButton from "./subscription/button";
import SubscriptionDetails from "./subscription/details";
import { setSubscription } from "api/subscription";

const UserDetails = (props) => {

    const { userId } = useParams();
    const dispatch = useDispatch();
    const navi = useNavigate();
    const requestId = useSelector(state => state.user.requestId);
    const [disableButton, setDisableButton] = useState(false);
    const subscriptionPopUp = useSelector(state => state.session.subscriptionPopUp);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [sb, setSB] = useState({ open: false, message: '', duration: 3000, severity: 'error' });

    const [userDeleteMutation] = useUserDeleteMutation();
    const [disableUser] = useDisableUserMutation();


    const handleCancel = () => {
        navi("/users/list")
    }

    const handleDisableUser = () => {
        setDisableButton(true);
        disableUser({
            email: userDetails.username,
            id: userDetails.id,
            disable: userDetails.status
        })
            .unwrap()
            .then(result => {
                setSB({ ...sb, open: true, message: userDetails.status ? "User Disabled" : "User Enabled", severity: "warning" });
                dispatch(resetRequestId());
                setTimeout(() => {
                    setDisableButton(false);
                }, 5000)
            })
            .catch(err => {
                setSB({ ...sb, open: true, message: err.message });
                setDisableButton(false);
            })
    }

    const handleDelete = () => {
        setDisableButton(true)
        userDeleteMutation({ id: userDetails.id, email: userDetails.username })
            .unwrap()
            .then(result => {
                setDisableButton(false);
                navi("/users/list")
            })
            .catch(err => {
                setDisableButton(false);
                navi("/users/list")
            })

    }

    const handleEdit = () => {
        setDisableButton(true)
        navi(`/users/edit/${userDetails?.id}`);

    }

    const { userDetails } = useUserDetailsQuery(
        {
            id: userId,
            requestId: requestId
        },
        {
            skip: !userId,
            selectFromResult: ({ data }) => ({
                userDetails: data || {}
            })
        }
    );

    const { smDetails } = useUserDetailsQuery(
        {
            id: userDetails.smId,
            requestId: requestId
        },
        {
            skip: !userDetails.smId,
            selectFromResult: ({ data }) => ({
                smDetails: data || {}
            })
        }
    );

    const { cognitoDetails } = useUserCognitoDetailsQuery({ email: userId },
        {
            skip: !userId,
            selectFromResult: ({ data }) => ({
                cognitoDetails: data || {}
            })
        }
    );



    const { orgDetails } = useOrgDetailsQuery({ id: userDetails.orgId },
        {
            skip: !userDetails.orgId,
            selectFromResult: ({ data }) => ({
                orgDetails: data || {}
            })
        }
    );

    const { roleDetails } = useGetRoleByCodeQuery({ code: userDetails.role },
        {
            skip: !userDetails.role,
            selectFromResult: ({ data }) => ({
                roleDetails: data || {}
            })
        }
    );


    return (
        <React.Fragment>
            <Container maxWidth={'lg'} sx={{ marginTop: "130px", marginBottom: "50px" }}>
                <Card elevation={10} >
                    <ChangePassword
                        {...{
                            showChangePassword: showChangePassword,
                            setShowChangePassword: setShowChangePassword
                        }}
                    />
                    <CardActions sx={{ padding: "15px" }}>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleCancel()}
                        >
                            Cancel
                        </Button>
                        <Typography sx={{ flexGrow: 1 }} />
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleDisableUser()}
                            color={'warning'}
                        >
                            {userDetails.status ? 'Disable User' : 'Enable User'}
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => setShowChangePassword(true)}
                            color={'warning'}
                        >
                            Change Password
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleEdit()}
                            color={'warning'}
                        >
                            Edit
                        </Button>
                        <Button
                            disabled={disableButton}
                            variant="outlined"
                            type="submit"
                            onClick={() => handleDelete()}
                            color={'warning'}
                        >
                            delete
                        </Button>
                    </CardActions>

                    <Header value={{ title: `User Details:`, description: "" }} />

                    {disableButton ? <LinearProgress /> : ''}
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                        <Grid item md={2}>
                            <Typography variant="h5">Name</Typography>
                        </Grid>
                        <Grid item md={4}>
                            <Typography variant="h6">{userDetails?.firstName || <Skeleton sx={{ margin: "0 50px 0 0" }} />} {userDetails?.lastName}</Typography>
                        </Grid>

                        <Grid item md={2}>
                            <Typography variant="h5">E-Mail</Typography>
                        </Grid>
                        <Grid item md={4}>
                            <Typography variant="h6">{userDetails?.username || <Skeleton sx={{ margin: "0 50px 0 0" }} />}</Typography>
                        </Grid>
                    </Grid>
                    <Divider sx={{ margin: "10px" }} />
                    <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                        <Grid item md={2}>
                            <Typography variant="h5">Phone</Typography>
                        </Grid>
                        <Grid item md={4}>
                            <Typography variant="h6">{userDetails?.phone_number || <Skeleton sx={{ margin: "0 50px 0 0" }} />}</Typography>
                        </Grid>
                        <Grid item md={2}>
                            <Typography variant="h5">Status</Typography>
                        </Grid>
                        <Grid item md={4}>
                            <Typography variant="h6">
                                {cognitoDetails.UserStatus === 'CONFIRMED' ?
                                    "Active" :
                                    cognitoDetails.UserStatus === 'FORCE_CHANGE_PASSWORD' ?
                                        "Change Password" : "Inactive"}</Typography>
                        </Grid>
                    </Grid>
                    {userDetails.role !== 'sa' ?
                        <React.Fragment>
                            <Header value={{ title: `Organization Details:`, description: "" }} />
                            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                                <Grid item md={2}>
                                    <Typography variant="h5">Role:</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">{roleDetails.name || <Skeleton sx={{ margin: "0 50px 0 0" }} />}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography variant="h5">Organization:</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">{orgDetails?.name || <Skeleton sx={{ margin: "0 50px 0 0" }} />}</Typography>
                                </Grid>
                            </Grid>
                            <Divider sx={{ margin: "10px" }} />
                            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                                <Grid item md={2}>
                                    <Typography variant="h5">Organization Phone</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">{orgDetails.phone_number || <Skeleton sx={{ margin: "0 50px 0 0" }} />}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography variant="h5">Organization E-Mail</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">{orgDetails.email || <Skeleton sx={{ margin: "0 50px 0 0" }} />}</Typography>
                                </Grid>
                            </Grid>
                            <Divider sx={{ margin: "10px" }} />
                            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                                <Grid item md={2}>
                                    <Typography variant="h5">Address: </Typography>
                                </Grid>
                                <Grid item md={10}>
                                    <Typography variant="h6">{orgDetails.address || <Skeleton sx={{ margin: "0 50px 0 0" }} />} {`${orgDetails.city || ''} ${orgDetails.state || ''}, ${orgDetails.zip || ''}` || <Skeleton sx={{ margin: "0 50px 0 0" }} />}</Typography>

                                </Grid>
                            </Grid>
                        </React.Fragment> : ""}
                    {userDetails.role === "adv" && smDetails?.username ?
                        <React.Fragment>
                            <Header value={{ title: `Service Manager Details:`, description: "" }} />
                            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                                <Grid item md={2}>
                                    <Typography variant="h5">Name:</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">{`${smDetails?.firstName} ${smDetails?.lastName}`}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography variant="h5">E-Mail:</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">{`${smDetails?.username} ${smDetails?.lastName}` || <Skeleton sx={{ margin: "0 50px 0 0" }} />}</Typography>
                                </Grid>
                            </Grid>
                            <Divider sx={{ margin: "10px" }} />
                            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                                <Grid item md={2}>
                                    <Typography variant="h5">Phone</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">{smDetails?.phone_number || <Skeleton sx={{ margin: "0 50px 0 0" }} />}</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography variant="h5">Status</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">{smDetails.status ? "Active" : "InActive"}</Typography>
                                </Grid>
                            </Grid>
                            <Divider sx={{ margin: "10px" }} />
                        </React.Fragment> : ""}

                    {userDetails.role === "acc" ?
                        <React.Fragment>
                            <Header value={{ title: `Payment Details:`, description: "" }} />
                            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                                <Grid item md={2}>
                                    <Typography variant="h5">Card Name:</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6"> "XXX"</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography variant="h5">Last 4 Digits of Card::</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">**** **** **** 1234</Typography>
                                </Grid>
                            </Grid>
                            <Divider sx={{ margin: "10px" }} />
                            <Grid container display={'flex'} justifyContent={'space-between'} alignItems={'center'} sx={{ padding: "10px", marginLeft: "20px" }}>
                                <Grid item md={2}>
                                    <Typography variant="h5">Expire Date:</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">03/31</Typography>
                                </Grid>
                                <Grid item md={2}>
                                    <Typography variant="h5">Status:</Typography>
                                </Grid>
                                <Grid item md={4}>
                                    <Typography variant="h6">Active</Typography>
                                </Grid>
                                <Divider sx={{ margin: "10px" }} />
                            </Grid>
                            <SubscriptionDetails />
                        </React.Fragment> : ""}


                </Card >
            </Container >
            {/* <Dialog anchor={"top"} open={subscriptionPopUp} onClose={() => dispatch(setSubscriptionPopUp(false))}>
                <SubscriptionPopUp />
            </Dialog> */}
        </React.Fragment >
    )


}

export default UserDetails;